var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 97,
    viewBox: "0 0 97 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 95,
    height: 95,
    rx: 23,
    fill: "url(#paint0_linear_171_242)",
    fillOpacity: 0.2,
    stroke: "url(#paint1_linear_171_242)",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.1667 32.5003H40.3C37.2197 32.5003 35.6796 32.5003 34.5031 33.0998C33.4682 33.6271 32.6268 34.4685 32.0995 35.5034C31.5 36.6799 31.5 38.22 31.5 41.3003V56.7003C31.5 59.7806 31.5 61.3208 32.0995 62.4973C32.6268 63.5322 33.4682 64.3736 34.5031 64.9009C35.6796 65.5003 37.2197 65.5003 40.3 65.5003H55.7C58.7803 65.5003 60.3204 65.5003 61.4969 64.9009C62.5318 64.3736 63.3732 63.5322 63.9005 62.4973C64.5 61.3208 64.5 59.7806 64.5 56.7003V50.8337M48 41.667H55.3333V49.0003M54.4167 33.417V30.667M61.6388 35.3615L63.5833 33.417M63.6021 42.5837H66.3521M31.5 51.47C32.6952 51.6546 33.9198 51.7503 35.1667 51.7503C43.2083 51.7503 50.3198 47.7676 54.6361 41.667",
    stroke: "#3D40D5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_171_242",
    x1: 0,
    y1: 0,
    x2: 97,
    y2: 97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2319B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_171_242",
    x1: 48.5,
    y1: 0,
    x2: 48.5,
    y2: 97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE25EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00568F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon-3.fd5a9475b40d188a51363337ba602d1e.svg";
export { ForwardRef as ReactComponent };